import {
  PosVendaConfirmacaoEnderecoCampo,
  PosVendaConfirmacaoEnderecoCampoMatchDto,
  PosVendaConfirmacaoEnderecoMatch,
  PosVendaConfirmacaoEnderecoOrigem,
  PosVendaEnderecoEntregaDivergencia,
  PosVendaEnderecoEntregaDto,
} from '../../types/posVenda';

export const CONFIRMACAO_ENDERECO_CAMPOS: Array<{
  campo: PosVendaConfirmacaoEnderecoCampo;
  label: string;
}> = [
  { campo: 'cep', label: 'CEP' },
  { campo: 'logradouro', label: 'Logradouro' },
  { campo: 'numero', label: 'Número' },
  { campo: 'complemento', label: 'Complemento' },
  { campo: 'bairro', label: 'Bairro' },
  { campo: 'cidade', label: 'Cidade' },
  { campo: 'uf', label: 'UF' },
];

export const ETIQUETA_MATCH: Record<PosVendaConfirmacaoEnderecoMatch, string> = {
  ok: 'Bate',
  divergente: 'Não bate',
  semDado: 'Sem dado',
};

export const ETIQUETA_ENTREGA_DIVERGENCIA: Record<PosVendaEnderecoEntregaDivergencia, string> = {
  ok: 'Bate',
  divergente: 'Não bate',
  semVtme: 'Sem VTME',
};

export const ROTULO_ORIGEM: Record<PosVendaConfirmacaoEnderecoOrigem, string> = {
  Gettel: 'Gettel (contrato)',
  Vtme: 'VTME',
  Manual: 'Digitado manualmente',
};

export function enderecoEntregaVazio(): PosVendaEnderecoEntregaDto {
  return {
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
  };
}

export function formatarEnderecoLinha(endereco: PosVendaEnderecoEntregaDto): string {
  const partes = [
    [endereco.logradouro, endereco.numero].filter(Boolean).join(', '),
    endereco.complemento?.trim(),
    endereco.bairro?.trim(),
    [endereco.cidade, endereco.uf].filter(Boolean).join('/'),
    endereco.cep?.trim() ? `CEP ${endereco.cep.trim()}` : '',
  ].filter(Boolean);
  return partes.join(' — ') || '—';
}

export function resumoConferenciaEndereco(matches: PosVendaConfirmacaoEnderecoCampoMatchDto[]): string {
  const divergentes = matches.filter((m) => m.match === 'divergente').length;
  const semDado = matches.filter((m) => m.match === 'semDado').length;
  if (divergentes > 0) return `Gettel × VTME: ${divergentes} campo(s) divergente(s)`;
  if (semDado > 0) return `Gettel × VTME: sem dado VTME em ${semDado} campo(s)`;
  return 'Gettel × VTME: endereços batem';
}

export function badgeClassMatch(match: PosVendaConfirmacaoEnderecoMatch): string {
  if (match === 'ok') return 'envios-badge envios-badge--ok';
  if (match === 'divergente') return 'envios-badge envios-badge--divergente';
  return 'envios-badge envios-badge--semVtme';
}

export function enderecoConfirmadoPreenchido(
  final: { origem: PosVendaConfirmacaoEnderecoOrigem; endereco: PosVendaEnderecoEntregaDto } | null | undefined
): boolean {
  if (!final?.origem || !final.endereco) return false;
  const endereco = final.endereco;
  const obrigatorios = [
    endereco.cep,
    endereco.logradouro,
    endereco.numero,
    endereco.bairro,
    endereco.cidade,
    endereco.uf,
  ];
  return obrigatorios.every((v) => String(v ?? '').trim().length > 0);
}
